export type ActionTab = 'obras' | 'materiales' | 'personas' | 'marketplace'

export interface WelcomeTourStep {
  id: string
  targetSelector?: string
  title?: string
  description: string
  position?: 'top' | 'bottom' | 'left' | 'right' | 'center'
  requiredTab?: ActionTab
  isIntro?: boolean
  illustration?: string
}

export const WELCOME_TOUR_STEPS: WelcomeTourStep[] = [
  {
    id: 'intro',
    title: 'Bienvenido a Edify',
    description: 'Te guiamos por las funciones principales. Avanzá a tu ritmo o saltá si preferís explorar por tu cuenta.',
    position: 'center',
    isIntro: true,
    targetSelector: '[data-tutorial="welcome-intro-fallback"]',
    illustration: 'welcome-tutorial',
  },
  {
    id: 'ai',
    targetSelector: '[data-tutorial="welcome-ai-input"]',
    title: 'Usá nuestra IA',
    description: 'Consultá obras, profesionales y datos del sector en lenguaje natural. Preguntale lo que necesites y te responde al instante.',
    position: 'top',
    illustration: 'ai-tutorial',
  },
  {
    id: 'obra',
    targetSelector: '[data-tutorial="tab-publicar"]',
    title: 'Publicá tu obra',
    description: 'Publicá tu proyecto y recibí cotizaciones de proveedores. Gestioná todo el proceso en un solo lugar.',
    position: 'bottom',
    illustration: 'project-empty-state',
  },
  {
    id: 'perfil',
    targetSelector: '[data-tutorial="tab-publicar"]',
    title: 'Completá tu perfil',
    description: 'Mostrá lo que hacés: sumá productos, servicios y un posteo para presentarte ante la comunidad.',
    position: 'bottom',
    illustration: 'profile-tutorial',
  },
  {
    id: 'materiales',
    targetSelector: '[data-tutorial="tab-herramientas"]',
    title: 'Precios de materiales',
    description: 'Armá listados y compartilos en la comunidad, o usá la calculadora con +3000 precios para estimar costos.',
    position: 'bottom',
    illustration: 'materials-empty-state',
  },
  {
    id: 'vacante',
    targetSelector: '[data-tutorial="tab-publicar"]',
    title: 'Cubrí una vacante',
    description: 'Publicá tu búsqueda laboral y recibí de forma organizada los datos de quienes se postulen.',
    position: 'bottom',
    illustration: 'workOffer-empty-state',
  },
]
